import preferences from 'Preferences';
import {Thunk} from 'redux-stores/Store';
import {ScrollableTablePreferences} from 'ui-library/scrollable/ScrollableTableConstants';

export enum ScrollableTableUIActionType {
  HIDDEN_COLUMNS_UPDATED = 'HIDDEN_COLUMNS_UPDATED',
}

interface UpdateHiddenColumnsAction {
  type: ScrollableTableUIActionType.HIDDEN_COLUMNS_UPDATED;
  tableKey: string;
  hiddenColumnKeys: Array<string>;
}

export function hiddenColumnsUpdated(
  tableKey: string,
  hiddenColumnKeys: Array<string>
): UpdateHiddenColumnsAction {
  return {
    type: ScrollableTableUIActionType.HIDDEN_COLUMNS_UPDATED,
    tableKey,
    hiddenColumnKeys,
  };
}

export function updateHiddenColumns(tableKey: string, hiddenColumnKeys: Array<string>): Thunk<void> {
  return (dispatch) => {
    preferences.set(`${tableKey}${ScrollableTablePreferences.HIDDEN_COLUMN_NAMESPACE}`, hiddenColumnKeys);
    dispatch(hiddenColumnsUpdated(tableKey, hiddenColumnKeys));
  };
}

export type ScrollableTableUIAction = UpdateHiddenColumnsAction;
